import { css } from '@emotion/core';
import { breakpoints } from 'src/design-system/constants';
import { left } from 'src/design-system/mixins';
import { Theme } from 'src/design-system/theme';

const container = () => (theme: Theme) =>
  css`
    border-left: 2px;
    border-left-style: solid;
    border-left-color: ${theme.colors.success};
  `;

const serverStatusIcon = (theme: Theme) => css`
  position: absolute;
  height: ${theme.sizes.lg}px;
  width: ${theme.sizes.lg}px;
  ${left(`${theme.sizes.md}px`)(theme)}
  top: 32px;
  bottom: 0;

  @media (min-width: ${breakpoints.md}px) {
    ${left(`${theme.sizes.lg}px`)(theme)}
  }
`;

export const style = {
  container,
  serverStatusIcon,
};
